<div class="sidenav" id="sidenav">  
    <div routerLink="/{{menuItem.id}}" [routerLinkActive]="['inactive', 'active']"
     *ngFor="let menuItem of menuItemlist">
     <span [ngClass]="menuItem.id == '1'? 'hide' : 'show'"><img class="sidemenuIcon"src="../../../../assets/images/sideMenu/{{menuItem.img}}.svg"/></span>
     <span class="menuItem">{{ menuItem.Item }}</span>
     </div>
 </div> 
 